<template>
  <!--优化前-->
  <div class="app-container">
    <div
        class="mobile-menu-toggle"
        @click="toggleMobileMenu"
    >
      <i class="layui-icon layui-icon-slider"></i>
    </div>

    <!-- 侧边菜单组件 -->
    <GameSidebar
        :active-menu="activeMenu"
        :mobile-open="mobileMenuOpen"
        @switch-menu="switchMenu"
    />

    <!-- 主内容区域 -->
    <div class="main-content">
      <!-- 顶部标题组件 -->
      <TopHeader
          :menu-title="getMenuTitle(activeMenu)"
          :version-data="versionData"
          :current-version-id="currentVersionId"
          :current-version-name="versionName"
      />

      <div class="content-area">
        <!-- 1. 轻量级加载提示（仅在内容区域顶部显示，不遮挡元素） -->
        <div class="light-loading" v-if="loading || menuLoading">
          <i class="layui-icon layui-icon-loading layui-icon-spin"></i>
          <span>{{ loading ? '页面数据加载中...' : `加载${getMenuTitle(activeMenu)}中...` }}</span>
        </div>

        <!-- 2. 错误提示（内容区域顶部，可重试） -->
        <div class="light-error" v-if="error">
          <i class="layui-icon layui-icon-face-cry"></i>
          <span>{{ error }}</span>
          <button class="retry-btn" @click="retryLoadData">重试</button>
        </div>

        <!-- 物品查询内容 -->
        <ItemQueryContent
            v-if="activeMenu === 'item' && !loading && !menuLoading && !error"
            :stditems-data="stditemsData"
            :monster-data="monsterData"
            :map-data="mapData"
            :monster-refresh="monsterRefresh"
            :initial-item-id="initialItemId"
        />

        <!-- 怪物查询内容 -->
        <MonsterQueryContent
            v-if="activeMenu === 'monster' && !loading && !menuLoading && !error"
            :monster-data="monsterData"
            :map-data="mapData"
            :monster-refresh="monsterRefresh"
            :stditems-data="stditemsData"
        />

        <!-- 地图查询内容 -->
        <MapQueryContent
            v-if="activeMenu === 'map' && !loading && !menuLoading && !error"
            :map-data="mapData"
            :monster-data="monsterData"
            :monster-refresh="monsterRefresh"
            :stditems-data="stditemsData"
        />
        <!-- NPC查询内容 -->
        <NpcQueryContent
            v-if="activeMenu === 'npc' && !loading && !menuLoading && !error"
        />

        <!-- 攻略内容 -->
        <StrategyContent
            v-if="activeMenu === 'strategy' && !loading && !menuLoading && !error"
            :strategy-content="strategyData || ''"
        />

        <!-- 修复记录内容 -->
        <RepairRecordContent
            v-if="activeMenu === 'repair' && !loading && !menuLoading && !error"
            :repair-content="repairData"
        />
      </div>
    </div>

    <!-- 固定底部备案信息 -->
    <footer class="fixed-footer">
      <div class="footer-content" ref="footerRef">
        <span v-if="qqgroupLink">
          <a :href="qqgroupLink" target="_blank">
            <span style="color:#666;">欢迎加入</span>
            <span style="color:#666;"><i class="layui-icon layui-icon-login-qq"></i>
              QQ群{{qqgroupNumber}}</span>&nbsp;
            <i class="layui-icon layui-icon-login-qq"></i>交流游戏
          </a>
        </span>
      </div>

      <!-- 滚动广告区域 -->
      <div class="advertising-scroll" v-if="adv && adv.length > 0">
        <div class="scroll-container">
          <transition-group name="scroll" tag="div" class="scroll-wrapper">
            <div
                v-for="item in [currentAdv]"
                :key="item.id"
                class="scroll-item"
            >
              <a :href="item.adv_link" target="_blank" class="adv-link">
                {{ item.title }}
              </a>
            </div>
          </transition-group>
        </div>
      </div>
    </footer>



  </div>
</template>

<script>
import GameSidebar from '../components/GameSidebar.vue';
import TopHeader from '../components/TopHeader.vue';
import ItemQueryContent from '../components/ItemQueryContent.vue';
import MonsterQueryContent from '../components/MonsterQueryContent.vue';
import MapQueryContent from '../components/MapQueryContent.vue';
import NpcQueryContent from '../components/NpcQueryContent.vue';
import StrategyContent from '../components/StrategyContent.vue';
import RepairRecordContent from '../components/RepairRecordContent.vue';
import EmptyContent from '../components/EmptyContent.vue';
import { fetchData, gamelist } from '@/utils/JSONHelper';

export default {
  name: 'GameDetail',
  components: {
    GameSidebar,
    TopHeader,
    ItemQueryContent,
    MonsterQueryContent,
    MapQueryContent,
    NpcQueryContent,
    StrategyContent,
    RepairRecordContent,
    EmptyContent,
  },
  data() {
    return {
      // 状态管理
      activeMenu: 'item',
      mobileMenuOpen: false,
      initialItemId: null,
      // 加载状态
      loading: true,
      menuLoading: false,
      error: '',
      // 新增：数据就绪状态标记
      dataReady: false,
      // 版本数据
      versionData: [],
      stditemsData: [],
      monsterData: [],
      versionName: '',
      currentVersionId: null,
      strategyData: '',
      repairData: '',
      miitbianInfo: '',
      qqgroupLink: '',
      qqgroupNumber: '',
      mapData: [],
      monsterRefresh: [],
      // 新增：数据加载锁，防止重复请求
      loadLock: false,
      adv: [],
      currentAdvIndex: 0,
      scrollTimer: null,
    };
  },
  created() {
    // 初始化路由参数
    this.initialItemId = this.$route.query.c_id ? parseInt(this.$route.query.c_id) : null;
    this.currentVersionId = this.initialItemId;
    // 合并所有数据加载逻辑
    this.initAllData();
  },
  watch: {
    // 监听路由参数变化
    '$route.query.c_id'(newVal) {
      const newItemId = newVal ? parseInt(newVal) : null;
      if (newItemId === this.initialItemId || this.loadLock) return;

      this.initialItemId = newItemId;
      this.currentVersionId = newItemId;
      this.dataReady = false;
      this.loading = true;
      if (newItemId) {
        this.initAllData();
      }
    }
  },
  computed: {
    getMenuTitle() {
      return (menu) => {
        const titles = {
          'item': '物品查询',
          'monster': '怪物查询',
          'map': '地图查询',
          'npc': 'NPC查询',
          'strategy': '版本攻略',
          'repair': '修复记录'
        };
        return titles[menu] || '未知';
      };
    },
    currentAdv() {
      if (this.adv && this.adv.length > 0) {
        return this.adv[this.currentAdvIndex];
      }
      return null;
    }
  },
  methods: {
    // 切换菜单（添加数据就绪判断）
    async switchMenu(menu) {
      // 数据未就绪时禁止操作
      if (!this.dataReady) {
        this.$message?.warning('数据加载中，请稍后...');
        return;
      }

      const needLoadData = ['item', 'monster', 'map'];
      if (needLoadData.includes(menu)) {
        this.menuLoading = true;
      }

      this.activeMenu = menu;
      this.mobileMenuOpen = false;

      if (needLoadData.includes(menu)) {
        try {
          // 菜单切换所需的额外数据加载
        } catch (err) {
          this.error = `加载${this.getMenuTitle(menu)}失败，请重试`;
        } finally {
          this.menuLoading = false;
        }
      }
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    // 合并所有数据加载，等待全部完成
    async initAllData() {
      // 防止重复加载
      if (this.loadLock) return;
      this.loadLock = true;
      this.loading = true;
      this.error = '';

      try {
        // 并行加载所有关键数据
        await Promise.all([
          this.getVersionData(),
          this.getConfigData(),
          this.getFetchData(),
            this.getAdv(),
        ]);

        // 验证核心数据是否加载完成（尤其是大数据量字段）
        const isAllDataValid =
            Array.isArray(this.stditemsData) && this.stditemsData.length > 0 &&
            Array.isArray(this.monsterData) && this.monsterData.length > 0 &&
            Array.isArray(this.mapData) && this.mapData.length > 0 &&
            Array.isArray(this.monsterRefresh) && this.monsterRefresh.length > 0;

        if (!isAllDataValid) {
          throw new Error('核心数据缺失，请重试');
        }

        // 所有数据就绪
        this.dataReady = true;
      } catch (error) {
        this.error = '数据加载失败：' + error.message;
        this.dataReady = false;
      } finally {
        this.loading = false;
        this.loadLock = false;
      }
    },
    async getVersionData() {
      try {
        const result = await gamelist('droprate/api.dropratelist');
        this.versionData = Array.isArray(result.data) ? result.data : [];
      } catch (error) {
        throw new Error('版本数据加载失败: ' + error.message);
      }
    },
    async getConfigData() {
      try {
        const result = await gamelist('admin/api.config/getconfig');
        if (result.code === 1 && typeof result.data === 'object') {
          this.miitbianInfo = result.data['miitbeian'] || '';
          this.statistics = result.data['statistics'] || '';
          this.qqgroupLink = result.data['qqgroup'] || '';

          // 提取QQ群号逻辑优化
          if (this.qqgroupLink) {
            try {
              const urlParams = new URLSearchParams(this.qqgroupLink.split('?')[1] || '');
              this.qqgroupNumber = urlParams.get('group_code') || '';

              // 备用提取方式
              if (!this.qqgroupNumber) {
                const match = this.qqgroupLink.match(/[?&]group_code=(\d+)/);
                this.qqgroupNumber = match ? match[1] : '';
              }
            } catch (e) {
              //console.warn('提取QQ群号失败:', e);
              this.qqgroupNumber = '';
            }
          }
        } else {
          throw new Error(result.info || '配置数据请求失败');
        }
      } catch (err) {
        throw new Error('配置数据加载失败: ' + err.message);
      }
    },
    async getAdv(){
      try{
        this.loading = true;
        const rs = await gamelist('adv/api.advapi');
        if(rs.code === 1){
          this.adv = rs.data;
        }else{
          this.errorMessage = rs.info || '请求失败';
        }
      }catch(error){
        this.errorMessage = '网络请求异常: ' + error.message;
      }finally{
        this.loading = false;
      }
    },
    async getFetchData() {
      try {
        // 并行加载核心数据和大数据量的怪物刷新数据
        const [stditemsResponse, monsterRefreshRes] = await Promise.all([
          fetchData({ type: 'stditems', id: this.initialItemId }),
          fetchData({ type: 'monsterRefresh', id: this.initialItemId })
        ]);

        if (stditemsResponse.code !== 1) {
          throw new Error(stditemsResponse.info || '物品数据获取失败');
        }

        // 处理大数据量的怪物刷新数据（分批处理优化）
        if (Array.isArray(monsterRefreshRes.data)) {
          //console.log('怪物刷新数据长度:', monsterRefreshRes.data.length);
          this.monsterRefresh = [];
          const batchSize = 500; // 分批处理，每批500条

          // 分批次处理大数据，避免阻塞
          for (let i = 0; i < monsterRefreshRes.data.length; i += batchSize) {
            const batch = monsterRefreshRes.data.slice(i, i + batchSize);
            const processed = batch.map(item => ({
              c_mongen_id: Number(item.c_mongen_id),
              c_goods: item.c_goods,
              c_refresh: item.c_refresh
            }));
            this.monsterRefresh.push(...processed);
            // 每批处理完让出主线程
            await new Promise(resolve => setTimeout(resolve, 0));
          }
          //console.log('处理完毕，已处理数据长度:', this.monsterRefresh);
        }

        // 处理其他核心数据
        const versionItem = Array.isArray(stditemsResponse.data) && stditemsResponse.data[0] || {};
        this.versionName = versionItem['c_name'] || '未知版本';
        this.stditemsData = Array.isArray(versionItem['c_goods']) ? versionItem['c_goods'] : [];
        this.strategyData = versionItem['c_strategy'] || '';
        this.repairData = versionItem['c_desc'] || '';
        this.monsterData = Array.isArray(versionItem['c_mongen']) ? versionItem['c_mongen'] : [];
        this.mapData = Array.isArray(versionItem['c_map']) ? versionItem['c_map'] : [];

        this.updatePageTitle(this.versionName);
      } catch (error) {
        throw new Error('核心数据加载失败: ');
      }
    },
    updatePageTitle(versionName) {
      document.title = `【${versionName}】 - 爆率查询 `;
    },
    retryLoadData() {
      this.error = '';
      this.dataReady = false;
      this.initAllData();
    },
  }
};
</script>


<style scoped>
/* 滚动广告样式 */
.advertising-scroll {
  height: 25px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scroll-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.scroll-content {
  transition: transform 0.5s ease-in-out;
  will-change: transform;
}

.scroll-item {
  height: 25px;
  line-height: 25px;
  text-align: center;
  font-size: 12px;
}

.adv-link {
  color: #fff;
  text-decoration: none;
  transition: color 0.3s;
  padding-left:10px;
  padding-right:10px;
  background: #1890ff;
  border-radius: 2px;
}

.adv-link:hover {
  color: #ff3300;
  text-decoration: underline;
}
/* 引入全局样式 */
@import '../assets/game-query.css';
/* 轻量级加载提示：内容区域顶部，不遮挡元素 */
.light-loading {
  padding: 15px 0;
  text-align: center;
  color: #666;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* 轻量级错误提示 */
.light-error {
  padding: 15px;
  text-align: center;
  color: #ff4d4f;
  font-size: 14px;
  background: #fff2f0;
  border-radius: 4px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

/* 重试按钮 */
.retry-btn {
  padding: 4px 12px;
  background: #1890ff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: background 0.3s;
}

.retry-btn:hover {
  background: #096dd9;
}

/* 新增底部功能样式 */
.app-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 20px;
  background-color: #fff;
  border-top: 1px solid #eee;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
  z-index: 99999;
}

.footer-content {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;     /* 垂直居中 */
  height: 100%;
}

.footer-info {
  font-size: 12px;
  color: #666;
}

.footer-info p {
  margin: 0;
  line-height: 1.4;
}



/* 移动端适配优化 */
@media (max-width: 992px) {
  .main-content {
    margin-left: 0;
    transition: margin-left 0.3s;
  }

  .mobile-menu-open .main-content {
    margin-left: 200px;
  }
}
/* 响应式调整底部区域 */
@media (max-width: 768px) {
  .app-footer {
    height: auto;
    padding: 10px 0;
  }

  .footer-content {
    flex-direction: column;
    gap: 10px;
    padding: 10px;
  }

  .footer-info{
    width: 100%;
    text-align: center;
    justify-content: center;
  }
}
</style>
